export class compareFormController {
    productID: any;
    nameOfProduct: any;
    url: any;
    allproduct: any;
    BrandID: any;
    nameOfBrand: any;
    constructor(private ProductCompareService, private $location, private $rootScope) {
        "ngInject"
    }

    $onInit() {
        this.url = this.$location.path().split('/');
    }

    setBrand(brand, noItem) {
        this.nameOfBrand = brand.Name;
        this.BrandID = brand.ManufacturerID;
        this.ProductCompareService.GetAllProduct(brand.ProductTypeID, brand.ManufacturerID)
            .then((res) => {
                this.allproduct = res.data;
            })
    }

    checkExist(product) {
        var exist = false;
        angular.forEach(this.url, function (val, key) {
            if (product == val) {
                exist = true;
            }
        })
        if (exist) {
            return false
        } else {
            return true
        }

    }

    setProduct(product, noItem) {
        this.nameOfProduct = product.ProductName;
        this.productID = product.ProductID;
    }

    AddToCompare(ProductID) {
        var currentUrl = this.$location.path() + '/' + ProductID
        this.$location.path(currentUrl)
        // this.$onInit();
        this.$rootScope.$emit('$routeChangeSuccess')
    }
}


// WEBPACK FOOTER //
// ./src/components/compare-form/compare-form.controller.ts